import Layout from '@/layout/layout'

export default {
    path: '/onlinSalemachines',
    component: Layout,
    redirect: 'noRedirect',
    name: '线上旧机售卖',
    children: [{
        path: 'productList',
        component: () => import('@/views/onlinSalemachines/productList/index'),
        name: '商品列表',
        meta: {
            title: '商品列表',
            noCache: true
        }
    }, {
        path: 'salesOrder',
        component: () => import('@/views/onlinSalemachines/salesOrder/index'),
        name: '销售订单',
        meta: {
            title: '销售订单',
            noCache: true
        }
    }, {
        path: 'Saleorderdetails',
        component: () => import('@/views/onlinSalemachines/Saleorderdetails/index'),
        name: '订单详情',
        meta: {
            title: '订单详情',
            noCache: true
        }
    }, ]
}
